import { h } from 'preact'
import clsx from 'clsx'

interface BadgeData {
  title: string
  text_colour: string
  background_colour?: string
  image?: string
}

interface BadgeProps {
  badge: BadgeData
}

const TextBadge = ({ badge }: { badge: BadgeData }) => {
  return (
    <div
      className={clsx('shrink-0 flex w-fit text-[--text-colour] bg-[--bg-colour]', {
        'px-0.5 py-0.25': badge.background_colour
      })}
      style={{
        '--text-colour': badge.text_colour,
        '--bg-colour': badge.background_colour || 'transparent'
      } as React.CSSProperties}
    >
      <span className="text-xxs tracking-[0.2px] uppercase">{badge.title || 'Metafield needs to be upgraded to use Title field'}</span>
    </div>
  )
}

const ImageBadge = ({ badge }: { badge: BadgeData }) => (
  <div className="flex size-fit">
    <img src={badge.image} className="w-auto h-auto" alt={badge.title || 'Badge'} />
  </div>
)

export const Badge = ({ badge }: BadgeProps) => {
  if (!badge) return null

  return badge.image ? <ImageBadge badge={badge} /> : <TextBadge badge={badge} />
}
